import styled from 'styled-components';

const AlertStyles = styled.div`
  position: fixed;
  top: 32px;
  z-index: 9;
  background: #fff;
  right:auto;
  margin:0 auto;
  left: calc(100% - 45%);
    transform: translateX(-45%);
  @media (max-width: 1024px) {
    .MuiBox-root {
      min-width:auto;
    }
  }
  @media (max-width: 767px) {
   left:auto;
   top:15px;
transform:none;
  }
`

export default AlertStyles